import { ButtonCross } from 'components/buttons';

import type { ModalProps } from 'components/Modal';
import { use100vh } from 'hooks/realHeight';
import { forwardRef } from 'react';
import type { ScModalTemplateProps } from './styled';
import { ScModalTemplate } from './styled';

interface ModalTemplateProps extends ModalProps, ScModalTemplateProps {
  className?: string;
  footer?: React.ReactNode;
  title?: React.ReactNode;
  mobileSubtitle?: React.ReactNode;
  description?: React.ReactNode;
  isButtonCrossHidden?: React.ReactNode;
  isCrossSquare?: boolean;
}

export const ModalTemplate = forwardRef<HTMLDivElement, ModalTemplateProps>(
  (
    {
      footer,
      title,
      mobileSubtitle,
      description,
      settings,
      onClose,
      isButtonCrossHidden = false,
      children,
      isCrossSquare = true,
      ...props
    },
    ref
  ) => {
    const hasTitleOrDescription = title != null || description != null;

    const isNotBottomMode = settings.mode.type !== 'bottom';

    const isBottomMode = settings.mode.type === 'bottom';

    const isBottomModeWithDescription = description != null && isBottomMode;

    const shouldRenderHeadline =
      isBottomModeWithDescription || (hasTitleOrDescription && isNotBottomMode);

    const isMobile = settings.type === 'mobile';

    // Over full-screen artwork the cross needs a soft backdrop to stay legible,
    // where a card gives it a solid one.
    const isOverBackground =
      isMobile &&
      (settings.mode.type === 'background' ||
        settings.mode.type === 'background-custom');

    const height = use100vh();

    const shouldShowMobileSubtitle = mobileSubtitle && isMobile && isBottomMode;

    return (
      <ScModalTemplate height={height} settings={settings} {...props}>
        <div className="container" ref={ref}>
          {title && isMobile && isBottomMode && (
            <div className="title">{title}</div>
          )}
          <div className="inner">
            <div className="body">
              {!isButtonCrossHidden && (
                <ButtonCross
                  onClick={onClose}
                  square={isCrossSquare}
                  transparent={isOverBackground}
                />
              )}
              {shouldRenderHeadline && (
                <div className="headline">
                  {title && isNotBottomMode && (
                    <div className="title">{title}</div>
                  )}
                  {description && (
                    <div className="description">{description}</div>
                  )}
                </div>
              )}
              {shouldShowMobileSubtitle && (
                <div className="subtitle">{mobileSubtitle}</div>
              )}
              {children}
            </div>
            {footer && <div className="footer">{footer}</div>}
          </div>
        </div>
      </ScModalTemplate>
    );
  }
);
